import { useState, Suspense } from "react"
import StandingsAuditUser from './StandingsAuditUser.jsx'
import { Tooltip } from 'react-tooltip'
import { enshortenName, maxNameAllowed } from "../utils/string.js"

export default function StandingDetails({groupId, standingRow}) {
  const [showAuditUser, setShowAuditUser] = useState(false)

  function handleAuditUserClick() {
    setShowAuditUser(!showAuditUser)
  }

  return (
    <>
      <tr className="text-right" key={"tr|" + groupId + "|" + standingRow.user.id} id={"tr|" + groupId + "|" + standingRow.user.id}>
        <td className="p-2">{standingRow.points.position_label}</td>
        <td className="p-2 text-left">
          {standingRow.points.diff != null && standingRow.points.diff > 0 && (
            <span className="mr-1 inline-block bg-green-600 text-white text-xs font-semibold px-1 py-0.5 rounded-md">
              +{standingRow.points.diff}
            </span>
          )}
          {standingRow.points.diff != null && standingRow.points.diff < 0 && (
            <span className="mr-1 inline-block bg-red-600 text-white text-xs font-semibold px-1 py-0.5 rounded-md">
              {standingRow.points.diff}
            </span>
          )}
          <span alt="Ver palpites" onClick={handleAuditUserClick} className="font-medium text-green-600 hover:underline cursor-pointer" id={`standing-details-${groupId}-${standingRow.user.id}`}>
            {enshortenName(standingRow.user.name)}
          </span>
          <Tooltip anchorSelect={`#standing-details-${groupId}-${standingRow.user.id}`} place="top" type="dark" effect="float">
            {`Auditar: ${maxNameAllowed(standingRow.user.name)}`}
          </Tooltip>
        </td>
        <td className="p-2">{standingRow.points.total}</td>
        <td className="p-2">{standingRow.points.ten_points}</td>
        <td className="p-2">{standingRow.points.seven_points}</td>
        <td className="p-2">{standingRow.points.five_points}</td>
        <td className="p-2">{standingRow.points.two_points}</td>
      </tr>
      {showAuditUser && (
        <Suspense key={"suspense|" + standingRow.user.id + " " + groupId} fallback={<p>Carregando...</p>}>
          <StandingsAuditUser key={standingRow.user.id + " " + groupId} userId={standingRow.user.id} OnAuditUserClick={handleAuditUserClick} userName={standingRow.user.name} groupId={groupId} standingsAuditUserPage={1} totalPoints={standingRow.points.total} includeLiveMatches={standingRow.points.diff != null} />
        </Suspense>
      )}
    </>
  )
}
